export default __webpack_public_path__ + "svg/ceo/growing.svg?c8393071";